import moment from "moment"
import AppLocale from "../../config/lang";

export default (context) => {
  const datestypes =   
  [
    {
      value: "typeAcadYear",
      label: "admCalendar.typeAcadYear"
    },
    {
      value: "typeAcadPeriod",
      label: "admCalendar.typeAcadPeriod"
    },
    {
      value: "typeVacations",
      label: "admCalendar.typeVacations"
    },
    {
      value: "typeHoliday",
      label: "admCalendar.typeHoliday"
    },
    {
      value: "typeSchoolAct",
      label: "admCalendar.typeSchoolAct"
    },
    {
      value: "typeAlteredTiming",
      label: "admCalendar.typeAlteredTiming"
    },
    {
      value: "typeStaffAbsence",
      label: "admCalendar.typeStaffAbsence"
    },
    {
      value: "other",
      label: "main.other"
    }
  ]

  const L = AppLocale['en'].messages
  const noClasses = L['admCalendar.noClasses']
  const chips = datestypes.reduce((a, v) => ({ ...a, [v.value]: {text: L[v.label], color:'gray'}}), {}) 


  return {
    config: {
      pageSize: 40,
      list: false,
      resource: "admResourceTime",
      remap: (r) => {
        r.data.Results.map(e => {
          e.from = moment(e.from).format('DD-MM-YYYY')
          e.to = moment(e.to).format('DD-MM-YYYY')
          return e
        })
        return r
      }
    },

    actions: {
      create: { reloadGrid: true },
      edit: { reloadGrid: true },
      delete: true,
      print: false,
      export: true,
      search: true
    },

    extras: {
      items: [ ],
      itemsInRowsTable: [],
      forms: []
    },

    filter: {
      fields: [
        {
          col: 3,
          name: "activityId",
          value: -1,
          type: "select",
          label: "admCalendar.academicYear",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: () => { return "/admActivity/get?type=ayr" }
          }
        },
        {
          col: 2,
          name: "inactive",
          value: false,
          type: "select",
          label: "Estado:",
          opts: {
            style: 'float-label',
            items: 
              [
                {
                  value: false,
                  label: "Activo"
                },
                {
                  value: true,
                  label: "Inactivo"
                }
              ]
          }
        }
      ],
      buttons: [
        {
          label: 'Aplicar filtro',
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      fields: [
        {
          col: 12,
          name: "name",
          value: "",
          type: "text",
          label: "main.desc",
          rules: 'required',
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 12,
          name: "desc",
          value: "",
          type: "select",
          label: "main.category",
          opts: {
            style: 'float-label',
            items: datestypes,
            isClearable: false
          }
        },
        {
          col: 6,
          name: "from",
          value: null,
          type: "date",
          label: "admCalendar.startDateTime",
          rules: "required",
          opts: {
            style: "float-label",
            isClearable: true,
            dateFormat: "DD/MM/YYYY",
            selectsStart: true,
            startDate: (ctx) => ctx.state.from ? moment(ctx.state.from) : null,
            endDate: (ctx) => ctx.state.to ? moment(ctx.state.to) : null
          },
        },
        {
          col: 6,
          name: "to",
          value: null,
          type: "date",
          label: "admCalendar.endDateTime",
          rules: "required",
          opts: {
            style: "float-label",
            isClearable: true,
            dateFormat: "DD/MM/YYYY",
            selectsEnd: true,
            startDate: (ctx) => moment(ctx.state.from),
            endDate: (ctx) => moment(ctx.state.to),
            minDate: (ctx) => moment(ctx.state.from)
          },
          renderIf: ctx => ctx.state.from
        },
        {
          col: 6,
          name: "noClasses",
          value: false,
          type: "switch",
          label: "admCalendar.noClasses",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "inactive",
          value: false,
          type: "switch",
          label: "main.inactive",
          opts: {
            style: 'float-label'
          }
        },
        {
          name: "onDemand",
          value: false,
          type: "hidden",
        },
        {
          name: "blocker",
          value: true,
          type: "hidden",
        },
        {
          name: "duration",
          value: 0,
          type: "hidden",
        },
      ],
      subGrids: [ ] 
    },

    columns: [
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: "main.category",
        accessor: "desc",
        type: 'chip',
        chips: chips
      },
      {
        Header: "admCalendar.startDateTime",
        accessor: "from"
      },
      {
        Header: "admCalendar.endDateTime",
        accessor: "to"
      },
      {
        Header: "",
        accessor: "noClasses",
        type: 'chip',
        chips: {
          true: {text: noClasses, color:'lightgreen'},
          false: {text:'', color:undefined}
        }
      }
    ]
  }
}